import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	AuthorizationsParams,
	GetAuthorizations,
	GetAuthorizationsModel,
} from 'domain/usecases/private/authorizations';

export class RemoteGetAuthorizations implements GetAuthorizations {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAuthorizationsModel>,
	) {}

	async get(params?: AuthorizationsParams): Promise<GetAuthorizationsModel> {
		const {signal, ...restParams} = params || {};

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: restParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
